function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9 15.4c-.7.6-1.4.5-1.9.2l-4.6-3.3c-.2-.1-.4-.2-.6-.2H.9c-.5 0-.9-.4-.9-.9V5.9c0-.7.6-1.4 1.4-1.4h4.3c.3 0 .5 0 .6-.2L10.8.6c.5-.4 1.2-.5 2 .1.2.1.3.5.3.7v13.2c.1.4 0 .6-.2.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.075 12.1l-.2-.2c-.5-.5-.5-1.2 0-1.7l1.9-1.9-1.9-1.9c-.5-.5-.5-1.2 0-1.7l.2-.2c.5-.5 1.2-.5 1.7 0l1.9 1.9 2-1.9c.5-.5 1.2-.5 1.7 0l.2.2c.5.5.5 1.2 0 1.7l-1.9 1.9 1.9 1.9c.5.5.5 1.2 0 1.7l-.2.2c-.5.5-1.2.5-1.7 0l-1.9-1.9-1.9 1.9c-.6.5-1.3.5-1.8 0z",
  fillRule: "nonzero"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16"
  }, props), _ref);
};

export default SvgComponent;